import { Minus, Plus } from "lucide-react";

export const QuantitySelector = ({ qty, onChange, small = false }) => (
  <div className="flex items-stretch border border-cocoa/25" data-testid="quantity-selector">
    <button
      type="button"
      data-testid="quantity-decrease"
      onClick={() => onChange(qty - 1)}
      aria-label="Decrease quantity"
      className={`flex items-center justify-center text-cocoa transition-colors hover:text-gold ${
        small ? "h-8 w-8" : "h-[52px] w-12"
      }`}
    >
      <Minus size={14} strokeWidth={1.5} />
    </button>
    <span
      data-testid="quantity-value"
      className={`flex items-center justify-center border-x border-cocoa/25 text-sm ${
        small ? "h-8 w-10" : "h-[52px] w-14"
      }`}
    >
      {qty}
    </span>
    <button
      type="button"
      data-testid="quantity-increase"
      onClick={() => onChange(qty + 1)}
      aria-label="Increase quantity"
      className={`flex items-center justify-center text-cocoa transition-colors hover:text-gold ${
        small ? "h-8 w-8" : "h-[52px] w-12"
      }`}
    >
      <Plus size={14} strokeWidth={1.5} />
    </button>
  </div>
);
